module.exports = __webpack_public_path__ + "img/qh.aea870a8.png";